<template>
  <div class="Ticket">
    <van-button type="primary" @click="printTable">点击生成准考证图片，长按保存</van-button>
    <div class="AdmissionTicket" ref="ticket">
      <img class="seal" src="@/assets/seal.png" alt="" />
      <h2>{{ EB_Name }}</h2>
      <h1>准考证</h1>
      <img class="papers" :src="Photo" alt=""  crossOrigin="anonymous"/>
      <ul>
        <li>
          <label>考生姓名：</label>
          <span>{{ Name }}</span>
        </li>
        <li>
          <label>准考证号：</label>
          <span>{{ ExamNO }}</span>
        </li>
        <li>
          <label>性　　别：</label>
          <span>{{ Sex }}</span>
        </li>
        <li>
          <label>出生年月：</label>
          <span>{{ BirthDate }}</span>
        </li>
        <li>
          <label>报考专业：</label>
          <span>{{ MName }}</span>
        </li>
        <li>
          <label>报考等级：</label>
          <span>{{ GName }}</span>
        </li>
        <li
          v-if="
            new Date(ShowRoomTime) < new Date() &&
              ExamTime &&
              ExamTime.IsPub == 1
          "
        >
          <label>{{
            ExamTime.IsOnline == 1 ? "上传视频起止时间" : "考试时间"
          }}</label>
          <span
            >{{ ExamTime.ExamBeginDate }} 至 {{ ExamTime.ExamEndDate }}</span
          >
        </li>
        <li
          v-if="
            new Date(ShowRoomTime) < new Date() &&
              ExamTime &&
              ExamTime.IsPub == 1 &&
              ExamTime.IsOnline == 0
          "
        >
          <label>考试地点</label>
          <span>{{ ExamTime.ExamAddress }}</span>
        </li>
        <li
          v-if="
            new Date(ShowRoomTime) < new Date() &&
              ExamTime &&
              ExamTime.IsPub == 1 &&
              ExamTime.IsOnline == 0
          "
        >
          <label>考场</label>
          <span>{{ ExamTime.ExamRoom }}</span>
        </li>
        <li v-if="new Date(ShowRoomTime) > new Date()">
          <label>查询考场：</label>
          <span
            >{{ ShowRoomTime.split(" ")[0] }}——{{
              new Date(ShowRoomTime).getFullYear()
            }}-{{
              new Date(ShowRoomTime).getMonth() + 1 > 10
                ? new Date(ShowRoomTime).getMonth() + 1 + ""
                : "" + new Date(ShowRoomTime).getMonth() + 1
            }}-{{ new Date(ShowRoomTime).getDate() + 7 }}</span
          >
        </li>
        <div v-if="QrOption.text" v-qr="QrOption"></div>
        <p class="tip">
          温馨提示：请牢记{{
            new Date(ShowRoomTime) > new Date() ? "查询考场" : "考试"
          }}的时间，如有需要，可长按保存。
        </p>
      </ul>
    </div>
    <img id="downimg" src="" style="display: none;"></img>
  </div>
</template>

<script>
import { GetExamFormInfo, CreateExamNo } from "@/api/exam";
import html2canvas from "html2canvas";
import AESUtil from "../Utils/AES.js";
export default {
  props: {
    EF_ID: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      EB_Name: "",
      ExamNO: "",
      Photo: "",
      CheckStatus: "",
      Fee: 0,
      EAName: "",
      MName: "",
      GName: "",
      Name: "",
      NameSpell: "",
      Sex: "",
      CertNO: "",
      BirthDate: "",
      PName: "",
      PMobile: "",
      CreateTime: "",
      ip: "",
      ExamTime: null,
      ShowRoomTime: null,
      QrOption: { text: "", width: 250, height: 250, IsShow: false }
    };
  },
  methods: {
    printTable() {
      html2canvas(this.$refs.ticket, {
        scale:4 ,
        allowTaint: true,
        useCORS: true,
        height: this.$refs.ticket.scrollHeight,
        windowHeight: this.$refs.ticket.scrollHeight
      }).then(canvas => {
        var url = canvas.toDataURL(); //把canvas转成base64
        // 写一个隐藏的按标签，借助按标签的download属性下载图片
        window.location.href = url;
        document.querySelector(
          "#downimg"
        ).src = url;
        document.querySelector("#downimg").style="display:block";
        this.$refs.ticket.style="display:none";
      });
    }
  },
  mounted() {
    if (this.EF_ID != undefined && this.EF_ID > 0) {
      GetExamFormInfo({ EF_ID: this.EF_ID })
        .then(res => {
          let ExamInfo = res.item;
          this.EB_Name = ExamInfo.ExamBatch.EB_Name;
          this.ExamNO = ExamInfo.ExamNO;
          this.Photo = ExamInfo.Photo+ '?' + new Date().getTime();
          this.CheckStatus = ExamInfo.CheckStatus;
          this.Fee = ExamInfo.Fee;
          this.EAName = ExamInfo.ExamArea.EA_Name;
          this.MName = ExamInfo.Majors.MName;
          this.GName = ExamInfo.Grades.GName;
          this.Name = ExamInfo.Name;
          this.NameSpell = ExamInfo.NameSpell;
          this.Sex = ExamInfo.Sex;
          this.CertNO = ExamInfo.CertNO;
          this.BirthDate = ExamInfo.BirthDate;
          this.PName = ExamInfo.PName;
          this.PMobile = ExamInfo.PMobile;
          this.CreateTime = ExamInfo.CreateTime;
          if (this.ExamNO == undefined || this.ExamNO == "") {
            CreateExamNo({ EF_ID: this.EF_ID }).then(res => {
              this.ExamNO = res.OtherMsg.ExamNO;
            });
          }
          this.ExamTime = ExamInfo.ExamTime;
          this.ShowRoomTime = ExamInfo.ExamBatch.ShowRoomTime.replace(
            /-/g,
            "/"
          );
          // this.ShowRoomTime = new Date("2022-01-01 00:00:00");

          let parms = {
            EF_ID: ExamInfo.EF_ID,
            Name: ExamInfo.Name,
            MName: ExamInfo.Majors.MName,
            GName: ExamInfo.Grades.GName,
            ExamNO: ExamInfo.ExamNO
          };

          this.QrOption.IsShow = true;
          this.QrOption.text = encodeURIComponent(
            AESUtil.encryptAES(JSON.stringify(parms))
          );
        })
        .catch(err => {
          this.$router.push("/MyEnroll");
        });
    } else {
      this.$router.push("/MyEnroll");
    }
  }
};
</script>

<style>
.tip {
  margin-top: 20px;
}
.AdmissionTicket {
  /* font-size: 3.8vw;
  letter-spacing: 1.5vw; */
  margin: 5%;
  border: double 4px #999;
  padding: 5%;
  text-align: center;
  background: #fff;
  position: relative;
  height: 90vh;
  overflow-y: auto;
}
.AdmissionTicket img {
  width: 30vw !important;
}
.AdmissionTicket .seal {
  width: 30vw;
  top: 28vh;
  position: absolute;
  left: 54%;
}
.AdmissionTicket .papers {
  width: 50%;
  border: double 3px #999;
}
.AdmissionTicket h1 {
  margin: 15px 0;
  font-weight: bold;
  font-size: 5.8vw;
}
.AdmissionTicket ul {
  width: 100%;
  margin: 15px auto;
}
.AdmissionTicket ul li {
  display: flex;
  justify-items: center;
  justify-content: space-between;
  padding: 5px 0;
}
.AdmissionTicket ul li label {
  flex: 3;
  font-weight: bold;
  text-align: right;
  margin-right: 10px;
}
.AdmissionTicket ul li span {
  border-bottom: solid 1px #999;
  flex: 7;
  padding: 3px 0 3px 15px;
  text-align: left;
}
</style>
